<template>
   <div class="credit-page">
    <el-select v-if="userInfo.avatar&&!changeAvater" size="small" style="width:200px;margin-left:calc(50% - 100px)"  v-model="year" placeholder="请选择年度" @change="getcreditInfo">
        <el-option v-for="item in yearList" :key="item" :value="item">{{item}}</el-option>
    </el-select>
    <button v-if="userInfo.avatar&&!changeAvater" style="display: inline-block;vertical-align: top;padding: 6px 10px;margin-top: 0px !important;margin-left: 5px;"  @click="changeAvater=true">修改证书头像</button>
    <UploadImg v-if="!userInfo.avatar||changeAvater" @upload-success="uploadSuccess"/>
     <div v-if="infoObject.name&&userInfo.avatar&&year&&!changeAvater" id="credit" :class="project">
        <img class="bg" src="../../assets/xueshiArms.png">
        
        <span class="name">{{infoObject.name}}</span>
        <span class="id-num">{{infoObject.id_number}}</span>
        <span class="num-1">{{infoObject.start_year}}</span>
        <span class="num-2">12</span>
        <span class="num-3">09</span>
        <span class="num-4">{{infoObject.hours}}</span>
        <span class="num-5">{{infoObject.date_year}}</span>
        <span class="num-6">{{infoObject.date_month}}</span>
        <span class="num-7">{{infoObject.date_day}}</span>
        <img class="avatar" :src="userInfo.avatar">
     </div>
     <button v-if="infoObject.name&&userInfo.avatar&&year&&!changeAvater"  @click="downloadImg">立即下载</button>
   </div>
</template>
<script>
import { mapState } from 'vuex'
import html2canvas from 'html2canvas'
import {  Option, Select } from "element-ui";
import UploadImg from './uploadImg.vue'
export default {
   name: '',
   components: {
     UploadImg,
     "el-select": Select,
    "el-option": Option,
   },
   mixins: [],
   props: {
     
   },
   data() {
     return {
       infoObject: {},
       yearList: [],
       year: '',
       changeAvater: false,
     }
   },
   computed: mapState([
        'project',
        'userInfo'
    ]),
   watch: {
     
   },
   mounted() {
     this.$http.get(`/api/user/getUserYear`).then(res => {
        if(res){
            this.yearList = res;
        }
    })
   },
   methods: {
    getcreditInfo(){
        this.$http.get(`/api/user/getUserHoursProof?year=${this.year}`).then(res => {
            if(res){
                this.infoObject = res;
            }
        })
    },
    uploadSuccess(url){
        console.log('uploadSuccess')
        this.changeAvater = false;
        this.userInfo.avatar = url
    },
     async downloadImg(){
        const domElement = document.getElementById('credit');
        // 使用 html2canvas 将 DOM 元素转换为 canvas
        const canvas = await html2canvas(domElement,{
            useCORS: true
        });

        // 将 canvas 的内容转换为 Base64 编码的图片数据
        const imageData = canvas.toDataURL('image/png');

        // 创建一个下载链接
        const downloadLink = document.createElement('a');
        downloadLink.href = imageData;
        downloadLink.download = '学时证明.png';

        // 触发下载
        downloadLink.click();
     },
   }
};
</script>
<style lang='scss' scoped>
.credit-page{
    width: 100%;
    height: 100%;
    padding: 20px 0;
    background-color: #fff;
    box-sizing: border-box;
}
#credit{
    width: 700px;
    height: 495px;
    position: relative;
    margin: auto;
    .bg{
        width: 100%;
        height: 100%;
    }
    .avatar{
        width: 70px;
        position: absolute;
        right: 86px;
        bottom: 255px;
        max-height: 180px;
    }
    span{
        position: absolute;
        display: inline-block;
        font-size: 13px;
        font-weight: 900;
        color: #000;
    }
    .name{
        top: 42.3%;
        left: 18%;
    }
    .id-num{
        top: 42.3%;
        left: 43%;
    }
    span:nth-child(4){
        width: 6.2%;
        height: 3%;
        text-align: center;
        top: 52.8%;
        left: 19.6%;
    }
    span:nth-child(5){
        width: 4%;
        height: 3%;
        text-align: center;
        top: 53%;
        left: 26.2%;
    }
    span:nth-child(6){
        width: 4%;
        height: 3%;
        text-align: center;
        top: 53%;
        left: 34.2%;
    }

    span:nth-child(7){
        width: 6.2%;
        height: 3%;
        text-align: center;
        top: 58.5%;
        left: 52.4%;
        // background-color: red;
    }
    span:nth-child(8){
        width: 5%;
        height: 3%;
        text-align: center;
        top: 81.5%;
        left: 62.8%;
        font-size: 12px;
        font-weight: 500;
    }
    span:nth-child(9){
        width: 4%;
        height: 3%;
        text-align: center;
        top: 81.5%;
        left: 69.5%;
        font-size: 12px;
        font-weight: 500;
    }
    span:nth-child(10){
        width: 3.4%;
        height: 3%;
        text-align: center;
        top: 81.5%;
        left: 75.3%;
        font-size: 12px;
        font-weight: 500;
    }
}
.arms{
    span:nth-child(4){
        left: 19.6% !important;
    }
    span:nth-child(5){
        display: none !important;
    }
    span:nth-child(6){
        display: none !important;
    }
    span:nth-child(7){
        left: 52.2% !important;
    }
}
.cco{
    span:nth-child(4){
        top: 52.7% !important;
        left: 19.6% !important;
    }
    span:nth-child(5){
        display: none !important;
    }
    span:nth-child(6){
        display: none !important;
    }
    span:nth-child(7){
        left: 42.7% !important;
    }
    span:nth-child(8){
        left: 62% !important;
        top: 81.3% !important;
        font-size: 12px !important;
        font-weight: 400 !important;
        color: #0c0807 !important;
    }
    span:nth-child(9){
        left: 68.5% !important;
        top: 81.3% !important;
        font-size: 12px !important;
        font-weight: 400 !important;
        color: #0c0807 !important;
    }
    span:nth-child(10){
        left: 74.2% !important;
        top: 81.3% !important;
        font-size: 12px !important;
        font-weight: 400 !important;
        color: #0c0807 !important;
    }
}

.ctco{
    span:nth-child(4){
        top: 52.8% !important;
        left: 20.1% !important;
    }
    span:nth-child(5){
        display: none !important;
    }
    span:nth-child(6){
        display: none !important;
    }
    span:nth-child(7){
        left: 36.7% !important;
    }
    span:nth-child(8){
        left: 63% !important;
        top: 82.9% !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        color: #0a0605 !important;
    }
    span:nth-child(9){
        left: 69.5% !important;
        top: 82.9% !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        color: #0a0605 !important;
    }
    span:nth-child(10){
        left: 75.2% !important;
        top: 82.9% !important;
        font-size: 12px !important;
        font-weight: 500 !important;
        color: #0a0605 !important;
    }
}

button {
  padding: 10px 20px;
  background-color: #285492;
  color: white;
  border: none;
  cursor: pointer;
  margin: auto;
  display: block;
  margin-top: 20px !important;
}

button:hover {
  background-color: #0056b3;
}
.forbidden{
  background-color: grey !important;
  cursor: not-allowed !important;
}
.forbidden:hover {
  background-color: grey !important;
}
</style>